import FBody from '@/plugins/form/FBody';
import FInput from '@/plugins/form/FInput';
import FDictionaryTypeTour from '@/modules/Dictionary/TypeTour/Select';
import FPartnerLegal from '@/modules/Partner/Legal/Select';
//import FDictionaryCurrency from "@/modules/Dictionary/Currency/Select";

export default class extends FBody {
  name = new FInput({
    label: 'Название тура',
    required: true,
  });

  type = new FDictionaryTypeTour({
    label: 'Тип тура',
    required: true,
  });

  legal = new FPartnerLegal({
    label: 'Юр. лицо',
    isMyAgency: true,
    required: true,
  });

  constructor(props = {}) {
    super(props);
    this.tour = props.parent;
    this.setItemName();
    this.setItemType();
    this.setItemLegal();
    // this.setItemCurrency();
  }

  get data() {
    const data = super.data;
    return {
      Name: data.name || '',
      TourTypeId: data.type || null,
      OwnerLegalId: data.legal || null,
      // CurrencyId: data.currency || null,
    };
  }

  set data(data) {
    this.name.set(data?.Name || '');
    this.type.set(data?.TourTypeId ? {
      value: data.TourTypeId,
      label: data.TourTypeName,
    } : null);

    this.legal.set(data?.OwnerLegalId ? {
      value: data.OwnerLegalId,
      label: data.OwnerLegalName,
    } : null);

  }

  set(value = {}) {
    this.name.set(value.name || '');
    this.type.set(value.type || '');
    this.legal.set(value.legal || '');
    // this.currency.set(value.currency || '');
    return this;
  }

  setItemName() {
    this.setItem('name', this.name);
  }

  setItemType() {
    this.setItem('type', this.type);
  }

  setItemLegal() {
    this.setItem('legal', this.legal);
  }

}
